import React from "react";
import { Table } from "react-bootstrap";

const DynamicTable = ({ headers, data, isDateSelected }: { headers: any; data: any, isDateSelected: boolean }) => {
  // console.log("Headers", headers);
  // console.log("Data", data);
  console.log("isDateSelected inside dynamic table", isDateSelected)
  const tableData = isDateSelected ? data : [data[data.length - 1]];

  return (
    <Table striped bordered>
      <thead className="font-13">
        <tr>
          {headers.map((header: any, index: any) => (
            <th
              key={index}
              style={{
                height: "40px",
                width: "80px",
                cursor: "default",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="font-13">
        { tableData.length > 0 && tableData.map((row: any, rowIndex: number) => (
          <tr key={rowIndex}>
            {row.map((cell: any, colIndex: number) => (
              <td
                key={colIndex}
                style={{
                  height: "40px",
                  cursor: "default",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DynamicTable;
